module.exports = __webpack_public_path__ + "img/imprimer-vos-livres-logo.b69a78f9.png";